var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 644 738.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f04858;\n      }\n      .skin {\n        fill: #dcba8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M582.76,738.35H61.41C86.46,612.54,193.65,518,322.09,518S557.71,612.54,582.76,738.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M580.78,277.23C564.87,429.38,465.2,554.54,322.62,554.46,185,554.39,75.35,429.89,64.46,277.23,50.93,87.39,180,0,322.62,0S602.2,72.39,580.78,277.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M123,323.33c0,29.3-25.55,53.06-57.06,53.06S0,369.32,0,340s34.42-69.73,65.94-69.73S123,294,123,323.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M644,337.2c0,30.68-40.4,37.19-69.93,37.19s-53.47-24.88-53.47-55.56,23.94-55.55,53.47-55.55S644,306.52,644,337.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "skin",
    points: "320 692.39 275.7 613.96 231.41 535.53 325.35 534.19 419.3 532.85 369.65 612.62 320 692.39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset5);
export default __webpack_public_path__ + "static/media/Asset 5.03a47112.svg";
export { ForwardRef as ReactComponent };